import React, { useEffect, useState } from 'react';
import Layouts from '../layouts/Layouts';
import { DinamicTitle } from '../utils/DinamicTitle';
import { getAuthorizationHeader, http } from '../config/http';
import TambahPengeluaran from './Modal/TambahPengeluaran';
import { IconChevronLeft, IconChevronRight, IconEdit, IconPlus, IconRefresh, IconReload, IconTrash } from '@tabler/icons-react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import { IconCalendarTime } from '@tabler/icons-react';
import { IconArrowsRightLeft } from '@tabler/icons-react';
import ConfirmationProsess from './Modal/ConfirmationProsess';
import LayoutsKasir from '../layouts/LayoutsKasir';
import ModalHapusPengeluaran from './Modal/ModalHapusPengeluaran';


const getTipeLabel = (tipe) => {
  switch (tipe) {
    case 'pemasukan': return 'Pemasukan';
    case 'tambah-kas': return 'Tambah KAS';
    case 'tarik-kas': return 'Tarik KAS';
    case 'm-banking': return 'M-Banking';
    case 'gaji-karyawan': return 'Gaji Karyawan';
    case 'indihome': return 'Indihome';
    case 'asuransi': return 'Asuransi';
    case 'listrik': return 'Listrik';
    case 'bensin': return 'Bensin';
    case 'parkir': return 'Parkir';
    case 'makan': return 'Makan';
    case 'donasi-santunan': return 'Donasi dan Santunan';
    case 'pengeluaran-lainnya': return 'Pengeluaran Lainnya';
    default: return tipe;
  }
};

function Pengeluaran() {
  DinamicTitle('Pengeluaran || Komaladewi');
  let [isOpenTambahPengeluaran, setIsOpenTambahPengeluaran] = useState(false);
  const navigate = useNavigate();
  function openModalTambahPengeluaran() {
    setFormData({ title: '-', tipe: '', keterangan: '', cabang_id: '' });
    setNominal(0);
    setIsEdit(false);
    setEditId(null);
    setIsOpenTambahPengeluaran(true);
  }

  function closeModalTambahPengeluaran() {
    setIsOpenTambahPengeluaran(false);
    setTimeout(() => {
      setFormData({ title: '-', tipe: '', keterangan: '', cabang_id: '' });
      setNominal(0);
      setIsEdit(false);
      setEditId(null);
    }, 200);
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const [pengeluaranHariIni, setPengeluaranHariIni] = useState([]);
  const [loadingPengeluaranHariIni, setLoadingPengeluaranHariIni] = useState(false);
  const [isSubmitPengeluaran, setIsSubmitPengeluaran] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  const [isOpenModalProses, setIsOpenModalProses] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [submitProsess, setSubmitProsess] = useState(false);

  const [cabang, setCabang] = useState([]);

  useEffect(() => {
    async function getCabang() {
      await http
        .get('/cabang', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setCabang(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          }
        });
    }
    getCabang();
  }, []);
  const [isProses, setIsProses] = useState(0);
  const [cabangId, setCabangId] = useState('');
  async function getPengeluaranHariIni() {
    setLoadingPengeluaranHariIni(true);
    await http
      .get(
        `cashflow?page=${currentPage}${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`
        }${cabangId === '' ? '' : `&cabang=${cabangId}`}${isProses === '' ? '' : `&is_proses=${isProses}`}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      )
      .then((res) => {
        setLastPage(res.data.data.last_page);
        setCurrentPage(res.data.data.current_page);
        setPengeluaranHariIni(res.data.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    setLoadingPengeluaranHariIni(false);
  }
  useEffect(() => {
    getPengeluaranHariIni();
  }, [isSubmitPengeluaran, currentPage, awal, akhir, isProses, cabangId, isProses, submitProsess]);
  function reloadPengeluaranHariIni(params) {
    let awal = null;
    let akhir = null;
    let isProsess = '';
    getPengeluaranHariIni();
    setEndDate(akhir);
    setStartDate(awal);
    setIsProses(isProses);
    setCabangId('');
  }

  const [formData, setFormData] = useState({
    title: '-',
    tipe: '',
    keterangan: '',
    cabang_id: '',
  });
  const [nominal, setNominal] = useState(0);

  function handleOnChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }
  const { title, tipe, cabang_id, keterangan } = formData;

  async function handleSubmitPengeluaran(e) {
    e.preventDefault();
    setLoadingSubmit(true);
    const data = { title, tipe, cabang_id, nominal, keterangan };
    try {
      const response = await http.post(`/cashflow`, data, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      toast.success(response.data.message, { autoClose: 600 });
      closeModalTambahPengeluaran();
      setTimeout(() => {
        setIsSubmitPengeluaran(true);
      }, 2000);
      setLoadingSubmit(false);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        navigate('/login');
      } else if (error.response?.status === 422) {
        toast.warning('Lengkapi input data', { autoClose: 600 });
      } else if (error.code === 'ERR_NETWORK') {
        toast.warning('Periksa jaringan internet', { autoClose: 600 });
      }
      setLoadingSubmit(false);
    }
    setIsSubmitPengeluaran(false);
    setLoadingSubmit(false);
  }
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  async function getDetailPengeluaran(id) {
    setLoading(true);
    await http.get(`/cashflow/${id}`, {
      headers: { Authorization: getAuthorizationHeader() },
    }).then((res) => {
      const data = res.data.data;
      setFormData({
        title: data.title || '-',
        tipe: data.tipe || '',
        keterangan: data.keterangan || '',
        cabang_id: data.cabang_id || '',
      });
      setNominal(data.nominal || 0);
      setEditId(id);
      setIsEdit(true);
      setIsOpenTambahPengeluaran(true);
    }).catch((error) => {
      console.log(`error : ${error}`);
    })
    setLoading(false);
  }

  async function handleEditPengeluaran(e) {
    e.preventDefault();
    setLoadingSubmit(true);
    const data = { title, tipe, cabang_id, nominal, keterangan };
    try {
      const response = await http.put(`/cashflow/${editId}`, data, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      toast.success('Data berhasil diupdate', { autoClose: 600 });
      closeModalTambahPengeluaran();
      getPengeluaranHariIni();
      setLoadingSubmit(false);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        navigate('/login');
      } else if (error.response?.status === 422) {
        toast.warning('Lengkapi input data', { autoClose: 600 });
      } else if (error.code === 'ERR_NETWORK') {
        toast.warning('Periksa jaringan internet', { autoClose: 600 });
      } else if (error.status === 404) {
        toast.error(error.response?.data?.message, { autoClose: 600 });
      }
      setLoadingSubmit(false);
    }
  }

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };
  function handleSelect(date) {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }
  async function submitProses(e) {
    e.preventDefault();
    setIsLoadingSubmit(true);
    await http
      .post(`submit_cashflow`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        closeModalProses();
        toast.success(res.data.message, { autoClose: 450 });
        setSubmitProsess(true);
        setTimeout(() => {
          setSubmitProsess(false);
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status == 404) {
          toast.warning('Tidak ada data', { autoClose: 600 });
        } else if (err.response.status == 401) {
          toast.warning(err.response.data.message, { autoClose: 600 });
        }
      });
    setIsLoadingSubmit(false);
  }

  function closeModalProses() {
    setIsOpenModalProses(false);
  }
  function openModalProses() {
    setIsOpenModalProses(true);
  }
  const [isOpenModalHapus, setIsOpenModalHapus] = useState(false);
  const [idHapus, setIdHapus] = useState(null)
  function closeModalHapus() {
    setIsOpenModalHapus(false)
  }
  function openModalHapus(id) {
    setIsOpenModalHapus(true)
    setIdHapus(id)
  }

  // ─── Shared Loading Overlay ───
  const LoadingOverlay = () => (
    <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
      <div className="w-12 h-12 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
    </div>
  );

  // ─── Shared Toolbar ───
  const Toolbar = ({ isKasir }) => (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-3 py-3 sm:px-4 bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700/60">
      <div className="flex items-center gap-2 flex-wrap">
        <select
          onChange={(e) => setCabangId(e.target.value)}
          className="border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500/40 cursor-pointer"
        >
          <option value="">Etalase</option>
          {cabang.map((cb) => (
            <option key={cb.id} value={cb.id}>
              {cb.nama_cabang}
            </option>
          ))}
        </select>
        <select
          onChange={(e) => setIsProses(e.target.value)}
          className="border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500/40 cursor-pointer"
        >
          <option value="">Status</option>
          <option value={0}>Belum diproses</option>
          <option value={1}>Sudah diproses</option>
        </select>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <button
          className="flex items-center gap-1.5 px-3 py-2 text-sm font-semibold bg-amber-500 hover:bg-amber-600 text-white rounded-md transition"
          onClick={openModalProses}
        >
          <IconArrowsRightLeft size={16} />
          Proses
        </button>
        <ConfirmationProsess
          submitProses={submitProses}
          closeModaProses={closeModalProses}
          isOpenModalProses={isOpenModalProses}
          isLoadingSubmit={isLoadingSubmit}
        />
        <button
          className="flex items-center gap-1.5 px-3 py-2 text-sm font-semibold bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white rounded-md shadow-sm transition-all"
          onClick={openModalTambahPengeluaran}
        >
          <IconPlus size={16} />
          Tambah
        </button>
      </div>
    </div>
  );

  // ─── Shared Loading Content ───
  const LoadingContent = () => (
    <div className="flex items-center justify-center py-12">
      <div className="flex items-center gap-3 text-sm text-slate-500 dark:text-slate-400">
        <div className="w-5 h-5 rounded-full animate-spin border-2 border-dashed border-amber-500 border-t-transparent"></div>
        Memuat data...
      </div>
    </div>
  );

  // ─── Shared Pagination ───
  const Pagination = () => (
    <div className="flex items-center justify-between px-3 py-3 sm:px-4 border-t border-slate-200 dark:border-slate-700/60 bg-slate-50 dark:bg-slate-800/50">
      <p className="text-xs sm:text-sm text-slate-500 dark:text-slate-400">
        Halaman <span className="font-semibold text-slate-700 dark:text-slate-300">{currentPage}</span> dari <span className="font-semibold text-slate-700 dark:text-slate-300">{lastPage}</span>
      </p>
      <div className="flex items-center gap-1">
        <button
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
          className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <IconChevronLeft size={16} />
        </button>
        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === lastPage}
          className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300 disabled:opacity-40 disabled:cursor-not-allowed transition"
        >
          <IconChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  // ─── Table Header Cell ───
  const Th = ({ children }) => (
    <th className="px-3 sm:px-4 py-2.5 text-left text-[10px] sm:text-xs font-semibold text-amber-800 dark:text-amber-500 uppercase tracking-wider whitespace-nowrap bg-amber-50/80 dark:bg-slate-800/80">
      {children}
    </th>
  );

  // ─── Table Data Cell ───
  const Td = ({ children, className = '' }) => (
    <td className={`px-3 sm:px-4 py-2.5 text-xs sm:text-sm text-slate-700 dark:text-slate-300 whitespace-nowrap border-b border-slate-100 dark:border-slate-700/50 ${className}`}>
      {children}
    </td>
  );

  const role = localStorage.getItem('role');
  if (role == 'kasir') {
    return (
      <LayoutsKasir
        title={'Pengeluaran Harian'}
        compFilter={
          <div className="flex gap-1.5">
            <button
              onClick={() => window.location.reload()}
              className="bg-slate-100 hover:bg-slate-200 text-slate-700 p-2 rounded-md transition"
              title="Refresh"
            >
              <IconReload size={20} />
            </button>
            <div className="dropdown dropdown-bottom">
              <div tabIndex={0} className="bg-amber-500 hover:bg-amber-600 text-white p-2 rounded-md cursor-pointer transition">
                <IconCalendarTime size={20} />
              </div>
              <div tabIndex={0} className="dropdown-content menu right-[45px]">
                <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
              </div>
            </div>
          </div>
        }
      >
        <div className="sm:mx-3 sm:my-2">
          {loading && <LoadingOverlay />}
          <TambahPengeluaran
            cabang={cabang}
            handleSubmitPengeluaran={handleSubmitPengeluaran}
            handleEditPengeluaran={handleEditPengeluaran}
            isEdit={isEdit}
            formData={formData}
            loadingSubmit={loadingSubmit}
            nominal={nominal}
            setNominal={setNominal}
            handleOnChange={handleOnChange}
            closeModalTambahPengeluaran={closeModalTambahPengeluaran}
            isOpenTambahPengeluaran={isOpenTambahPengeluaran}
          />
          <div className="bg-white dark:bg-slate-900 shadow-sm border-t sm:border sm:rounded-md border-slate-200 dark:border-slate-700/60 overflow-hidden">
            <Toolbar isKasir />
            {loadingPengeluaranHariIni ? (
              <LoadingContent />
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className="border-b border-slate-200 dark:border-slate-700/60">
                      <Th>No</Th>
                      <Th>Title</Th>
                      <Th>Nominal</Th>
                      {/* <Th>Keterangan</Th> */}
                      <Th>Tanggal</Th>
                      <Th>Diproses</Th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                    {pengeluaranHariIni.map((phi, i) => (
                      <tr key={phi.id} className="hover:bg-amber-50/40 dark:hover:bg-slate-800/50 bg-white dark:bg-slate-900 transition-colors">
                        <Td>{i + 1}</Td>
                        <Td>
                          <span className="font-medium text-slate-800 dark:text-slate-200">{getTipeLabel(phi.tipe)}</span><br />
                          <span className="text-xs text-slate-500 dark:text-slate-400">
                            {(phi.keterangan === '' || phi.keterangan === '.' || phi.keterangan === '-') ? '' : `(${phi.keterangan})`}
                          </span>
                        </Td>
                        <Td><span className="font-semibold text-slate-900 dark:text-slate-100">Rp {numberWithCommas(phi.nominal)}</span></Td>
                        {/* <Td>{phi.keterangan || <span className="text-slate-400 dark:text-slate-600">—</span>}</Td> */}
                        <Td>{phi.created_at}</Td>
                        <Td>
                          {phi.is_proses == 0 ? (
                            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400">Belum</span>
                          ) : (
                            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400">Proses</span>
                          )}
                        </Td>
                      </tr>
                    ))}
                    {pengeluaranHariIni.length === 0 && (
                      <tr className="bg-white dark:bg-slate-900">
                        <td colSpan={6} className="px-4 py-8 text-center text-sm text-slate-400 dark:text-slate-500">Tidak ada data pengeluaran.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <Pagination />
          </div>
        </div>
      </LayoutsKasir>
    );
  } else {
    return (
      <Layouts
        title={'Pengeluaran Harian'}
        compFilter={
          <div className="flex gap-1.5">
            <button
              onClick={reloadPengeluaranHariIni}
              className="bg-slate-100 hover:bg-slate-200 text-slate-700 p-2 rounded-md transition"
              title="Refresh"
            >
              <IconRefresh size={20} />
            </button>
            <div className="dropdown dropdown-bottom">
              <div tabIndex={0} className="bg-amber-500 hover:bg-amber-600 text-white p-2 rounded-md cursor-pointer transition">
                <IconCalendarTime size={20} />
              </div>
              <div tabIndex={0} className="dropdown-content menu right-[45px]">
                <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
              </div>
            </div>
          </div>
        }
      >
        {loading && <LoadingOverlay />}
        <ModalHapusPengeluaran
          idHapus={idHapus}
          closeModaLogout={closeModalHapus}
          isOpenModalLogout={isOpenModalHapus}
          getPengeluaranHariIni={getPengeluaranHariIni}
        />
        <div className="sm:mx-3 sm:my-2">
          <TambahPengeluaran
            cabang={cabang}
            handleSubmitPengeluaran={handleSubmitPengeluaran}
            handleEditPengeluaran={handleEditPengeluaran}
            isEdit={isEdit}
            formData={formData}
            loadingSubmit={loadingSubmit}
            nominal={nominal}
            setNominal={setNominal}
            handleOnChange={handleOnChange}
            closeModalTambahPengeluaran={closeModalTambahPengeluaran}
            isOpenTambahPengeluaran={isOpenTambahPengeluaran}
          />
          <div className="bg-white dark:bg-slate-900 shadow-sm border-t sm:border sm:rounded-md border-slate-200 dark:border-slate-700/60 overflow-hidden">
            <Toolbar />
            {loadingPengeluaranHariIni ? (
              <LoadingContent />
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className="border-b border-slate-200 dark:border-slate-700/60">
                      <Th>No</Th>
                      <Th>Title</Th>
                      <Th>Nominal</Th>
                      {/* <Th>Keterangan</Th> */}
                      <Th>Tanggal</Th>
                      <Th>Aksi</Th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                    {pengeluaranHariIni.map((phi, i) => (
                      <tr key={phi.id} className="hover:bg-amber-50/40 dark:hover:bg-slate-800/50 bg-white dark:bg-slate-900 transition-colors">
                        <Td>{i + 1}.</Td>
                        <Td>
                          <span className="font-medium text-slate-800 dark:text-slate-200">{getTipeLabel(phi.tipe)}</span><br />
                          <span className="text-xs text-slate-500 dark:text-slate-400">
                            {(phi.keterangan === '' || phi.keterangan === '.' || phi.keterangan === '-' || phi.keterangan === null) ? '' : `(${phi.keterangan})`}
                          </span>
                        </Td>
                        <Td><span className="font-semibold text-slate-900 dark:text-slate-100">Rp {numberWithCommas(phi.nominal)}</span></Td>
                        {/* <Td>{phi.keterangan || <span className="text-slate-400 dark:text-slate-600">—</span>}</Td> */}
                        <Td>{phi.created_at}</Td>
                        <Td>
                          {phi.is_proses === 0 ? (
                            <div className="flex items-center gap-1.5">
                              <button
                                onClick={() => getDetailPengeluaran(phi.id)}
                                className="inline-flex items-center justify-center w-7 h-7 rounded-md bg-amber-100 dark:bg-amber-900/40 hover:bg-amber-200 dark:hover:bg-amber-900/60 text-amber-700 dark:text-amber-400 transition"
                                title="Edit"
                              >
                                <IconEdit className="w-4 h-4" />
                              </button>
                              <button
                                onClick={() => openModalHapus(phi.id)}
                                className="inline-flex items-center justify-center w-7 h-7 rounded-md bg-red-100 dark:bg-red-900/30 hover:bg-red-200 dark:hover:bg-red-900/50 text-red-600 dark:text-red-400 transition"
                                title="Hapus"
                              >
                                <IconTrash className="w-4 h-4" />
                              </button>
                            </div>
                          ) : (
                            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-medium bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400">
                              Telah diproses
                            </span>
                          )}
                        </Td>
                      </tr>
                    ))}
                    {pengeluaranHariIni.length === 0 && (
                      <tr className="bg-white dark:bg-slate-900">
                        <td colSpan={6} className="px-4 py-8 text-center text-sm text-slate-400 dark:text-slate-500">Tidak ada data pengeluaran.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <Pagination />
          </div>
        </div>
      </Layouts>
    );
  }
}

export default Pengeluaran;
